import apiClient from "./apiClient";

const recommendationsApi = {
  // 📌 Obtener una recomendación por sección y nivel de riesgo (aún útil para búsquedas individuales)
  getBySectionAndLevel: async (section, riskLevel) => {
    try {
      const response = await apiClient.get("/recommendations", {
        params: { section, riskLevel }
      });
      return response.data;
    } catch (error) {
      console.error(`Error obteniendo recomendación para ${section} (nivel ${riskLevel}):`, error);
      throw error;
    }
  },

  // ✅ Obtener todas las recomendaciones de una sección (ordenadas por riskLevel asc)
  getAllBySection: async (section) => {
    try {
      const response = await apiClient.get(`/recommendations/section/${section}`);
      return response.data;
    } catch (error) {
      console.error(`Error obteniendo recomendaciones de la sección "${section}":`, error);
      throw error;
    }
  },

  // ✅ Actualizar una recomendación por ID
  updateRecommendationById: async (id, text) => {
    try {
      const response = await apiClient.put(`/recommendations/${id}`, { text });
      return response.data;
    } catch (error) {
      console.error(`Error actualizando recomendación con ID ${id}:`, error);
      throw error;
    }
  }
};

export default recommendationsApi;
